import React from 'react';
import cn from 'classnames';
import {StandardProps} from '.';

interface CheckboxSvgIconProps {
  className?: string;
}

function CheckSvg(props: CheckboxSvgIconProps) {
  return (
    <svg {...props} width="12" height="8" viewBox="0 0 12 8" focusable="false">
      <path d="M0.792909 3.29292C1.18343 2.9024 1.8166 2.9024 2.20712 3.29292L4.50001 5.58581L9.79288 0.292922C10.1834 -0.0976037 10.8166 -0.0976052 11.2071 0.292918C11.5976 0.683442 11.5976 1.31661 11.2071 1.70713L5.20712 7.70713C5.01959 7.89467 4.76523 8.00003 4.50002 8.00003C4.2348 8.00003 3.98044 7.89467 3.79291 7.70713L0.792908 4.70713C0.402384 4.31661 0.402384 3.68344 0.792909 3.29292Z" />
    </svg>
  );
}

function IndeterminateSvg(props: CheckboxSvgIconProps) {
  return (
    <svg {...props} width="12" height="2" viewBox="0 0 12 2">
      <path d="M0 1C0 0.447715 0.447715 0 1 0H11C11.5523 0 12 0.447715 12 1C12 1.55228 11.5523 2 11 2H1C0.447715 2 0 1.55228 0 1Z" />
    </svg>
  );
}

interface CheckboxProps extends StandardProps<React.HTMLAttributes<HTMLSpanElement>, 'onChange'> {
  checked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string;
  indeterminate?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  disabled,
  onChange,
  label,
  className,
  children,
  indeterminate,
  ...restProps
}) => {
  const handleChange = () => {
    onChange && !disabled && onChange(!checked);
  };

  const checkbox = (
    <span
      className={cn('checkbox', className, {
        checked: !!checked,
        disabled: !!disabled,
        indeterminate: !!indeterminate,
      })}
      onClick={label ? undefined : handleChange}
      {...restProps}
    >
      <span className="checkbox__icon">
        <CheckSvg className="checkbox__svg-icon" />
        {indeterminate && <IndeterminateSvg className="checkbox__svg-icon indeterminate" />}
      </span>
      {children ? <span className="checkbox__children">{children}</span> : null}
    </span>
  );

  if (label) {
    return (
      <div className="d-inline-flex" onClick={handleChange}>
        {checkbox}
        <div className="checkbox__label ml-3 cursor-pointer">{label}</div>
      </div>
    );
  }

  return checkbox;
};

export default Checkbox;
